import createReducer from "Common/reducerUtils/createReducer";
import actionTypes from "./actionTypes";
export const initialState = {
    backUrlHash: undefined
};
export default createReducer(initialState, {
    [actionTypes.SET_BACK_URL_HASH]: (state, { backUrlHash }) => ({
        ...state,
        backUrlHash
    })
});
